<template>
<div>
    <div v-if="loading" class="v-spinner-container">
        <vue-spinner></vue-spinner>
    </div>
    <template v-else-if="hasValue">
        <template v-if="!_.isEmpty(products)">
            <!-- <h1 class="text-center mt-5 product-page-title">Our Variants</h1> -->
            <div class="row ">
                <a v-for="product in products"
                   :href="getProductPath(product)"
                    class="col-6 col-lg-4 col-xl-3 products__list mb-4">
                    <div class="card">
                        <div :class="[
                            'card-header',
                            'products__list__thumb',
                            getProductStatus(product),
                        ]">
                            <div class="backorder-msg">
                                <p><span class="d-none d-sm-block">STOCK CURRENTLY</span> ON BACKORDER</p>
                                <p class="small">CONTACT US <span class="d-none d-sm-block">FOR MORE INFORMATION</span></p>
                                <a class="backorder-msg__link" :href="'tel:' + sitePhone"><img src="/img/site/icons/icon-phone-wh.svg"></a>
                                <a class="backorder-msg__link" :href="'mailto:' + siteEmail"><img src="/img/site/icons/icon-mail-wh.svg"></a>
                            </div>
                            <img :src="_.imgPath(product.image, 'w400_c400x245-q80')"
                                :alt="product.name" class="img-fluid">
                        </div>
                        <div class="card-body products__list__name">
                            <h4>{{ product.name }}</h4>
                        </div>
                    </div>
                </a>
            </div>
        </template>
        <template v-if="!_.isEmpty(categories)">
            <!-- <h1 class="text-center mt-5 product-page-title">Our Products</h1> -->
            <div class="row">
                <a v-for="cat in categories"
                    :href="'/our-products/' + cat.path"
                    class="col-6 col-lg-4 col-xl-3 products__list mb-4">
                    <div class="card">
                        <div class="card-header products__list__thumb">
                            <img :src="_.imgPath(cat.image, 'w400_c400x245-q80')"
                                :alt="cat.name" class="img-fluid">
                        </div>
                        <div class="card-body products__list__name">
                            <h4>{{ cat.name }}</h4>
                        </div>
                    </div>
                </a>
            </div>
        </template>
    </template>
    <p v-else class="alert alert-default">No products were found, please try a different keyword or search filter.</p>
</div>
</template>
<script>
import M from 'moment';
import VueSpinner from 'vue-spinner/src/MoonLoader.vue';
import UtilsMixin from './UtilsMixin';

export default {
    data() {
        return {
            loading: false,
            search: null,
            products: [],
            categories: [],
            filteredProductIds: null,
            filteredCategoryIds: null,
        }
    },

    created() {
        this.products = _.chain(this.initialData)
            .get('products')
            .value();

        this.categories = _.chain(this.initialData)
            .get('categories')
            .value();
    },

    mounted() {
        window.addEventListener('vue:product-list-loading', (e) => {
            // this.loading = true;
        })

        window.addEventListener('vue:product-list', (e) => {
            if (_.get(e, 'detail.products') !== undefined) {
                this.products = _.get(e, 'detail.products');
            }
            if (_.get(e, 'detail.categories') !== undefined) {
                this.categories = _.chain(e)
                    .get('detail.categories', [])
                    .sortBy((cat) => {
                        return cat.parent_id || 0;
                    })
                    .value();
            }
            if (_.get(e, 'detail.search') !== undefined) {
            this.search = _.get(e, 'detail.search');
            }
            this.$forceUpdate();
        })
    },

    props: ['initialData', 'config'],

    components: {
        VueSpinner,
    },

    mixins: [UtilsMixin],

    watch: {

    },

    computed: {
        topCategory() {
            return _.get(this.initialData, 'topCategory', null);
        },

        hasValue() {
            return !_.isEmpty(this.categories)
                || !_.isEmpty(this.products)
        },

        siteEmail() {
            return _.get(this.config, 'email', '');
        },

        sitePhone() {
            return _.get(this.config, 'phone', '');
        },
    },

    methods: {
        filterBy(key, val) {
            this.filter[key] = val;
        },

        getProductStatus(p) {
            if (p.status_new) {
                return 'products__list__thumb--new';
            }
            if (p.status_indent) {
                return 'products__list__thumb--indent';
            }
            if (p.status_backorder) {
                return 'products__list__thumb--backorder';
            }

            return '';
        },

        getProductPath(p) {
            let productPath = p.path;
            _.get(p, 'paths', [])
                .map(path => {
                    if (_.includes(path, window.location.pathname.replace(/^\//, ''))) {
                        productPath = path;
                    }
                })

            return '/' + productPath;
        },
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/site/js/components/ProductListComponent.vue